module.exports = __webpack_public_path__ + "static/media/CatarinaDuarteHover.79ed3220.png";